import { orderBy } from 'lodash';
import getMenu, { MenuItem } from './quickSearchMenuReader';

export interface MenuSearchResult {
    title: string;
    url: string;
}

export default function searchMenu(filter: string, menu: MenuItem): Promise<MenuSearchResult[]> {
    return new Promise((resolve) => {
        let results = getMenu(menu)
            .filter((item) => item.title.toLowerCase().includes(filter.toLowerCase()))
            .splice(0, 5);

        // Remove duplicates (e.g printing methods and tools > printing methods)
        results = results.filter((item, index, self) => self.findIndex((i) => i.url === item.url) === index);

        // Remove items without a URL
        results = results.filter((item) => item.url !== '');

        // Sort by the first match
        results = orderBy(results, (item) => item.title.toLowerCase().indexOf(filter.toLowerCase()));

        resolve(results);
    });
}
